import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";

const BrandAmbassadorSection = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 3, md: 8 },
        px: { xs: 1.5, md: 12.5 },
        bgcolor: "background.default",
      }}
    >
      <Stack spacing={{ xs: 2.5, md: 3.125 }}>
        <Typography
          variant="h2"
          color="text.secondary"
          textAlign="center"
          sx={{
            fontFamily: "Jost-Bold, Montserrat",
            fontWeight: 700,
            fontSize: { xs: 36, sm: 44, md: 64 },
            letterSpacing: { xs: "-2px", md: "-3.84px" },
          }}
        >
          OUR BRAND AMBASSADOR
        </Typography>

        <Grid
          container
          spacing={{ xs: 0, md: 8.5 }}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="AbuBakarTalha.png"
              alt="Brand Ambassador"
              sx={{
                width: { xs: "100%", sm: "80%", md: "100%" },
                maxWidth: { xs: 400, md: 572.51 },
                height: "auto",
                maxHeight: { xs: 420, md: 700 },
                borderRadius: { xs: "20px", md: "28px" },
                mx: "auto",
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack
              spacing={{ xs: 3, md: 6.4 }}
              textAlign={{ xs: "center", md: "left" }}
            >
              <Box>
                <Typography
                  variant="h2"
                  color="text.secondary"
                  sx={{
                    fontFamily: "Jost-Bold, Montserrat",
                    fontWeight: 700,
                    fontSize: { xs: 32, sm: 40, md: 64 },
                    letterSpacing: { xs: "-2px", md: "-3.84px" },
                    whiteSpace: { xs: "normal", md: "nowrap" },
                  }}
                >
                  Abu Bakar Talha
                </Typography>
                <Typography
                  variant="h4"
                  color="text.secondary"
                  sx={{
                    fontFamily: "Satoshi-Medium, Montserrat",
                    fontWeight: 500,
                    fontSize: { xs: 18, sm: 22, md: 32 },
                    letterSpacing: { xs: "-1px", md: "-1.92px" },
                  }}
                >
                  National Tennis Champion, Pakistan
                </Typography>
              </Box>

              <Typography
                variant="body1"
                color="text.primary"
                sx={{
                  fontFamily: "Poppins-Regular, Montserrat",
                  fontSize: { xs: 14, sm: 16, md: 20 },
                  lineHeight: 1.7,
                }}
              >
                Abu Bakar Talha is one of Pakistan's most accomplished tennis
                players, dominating the junior categories and representing the
                country on international platforms. His dedication and skill
                inspire the next generation of athletes.
              </Typography>

              <Box>
                <Typography
                  variant="h3"
                  color="text.secondary"
                  sx={{
                    fontFamily: "Satoshi-Bold, Montserrat",
                    fontWeight: 700,
                    fontSize: { xs: 20, sm: 24, md: 32 },
                    letterSpacing: { xs: "-1px", md: "-1.92px" },
                    mb: { xs: 1.5, md: 2 },
                  }}
                >
                  Career Highlights
                </Typography>
                <Typography
                  variant="body1"
                  color="text.primary"
                  sx={{
                    fontFamily: "Poppins-Regular, Montserrat",
                    fontSize: { xs: 14, sm: 16, md: 20 },
                    lineHeight: 1.7,
                  }}
                >
                  🏆 U-10, U-12, U-14, U-16, U-18 National Champion
                  <br />
                  🌍 Pakistan Junior Davis Cup Player
                  <br />
                  🎾 Winner of multiple Asia-ranking tennis championships in the
                  junior category
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};

export default BrandAmbassadorSection;
